import { j as t } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import o from "../../../../string-table.js";
import "@ionic/react";
import "../../../../../FeatureFlagProvider-DSFeeZ8R.js";
import "react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import { Section as p } from "../Section/Section.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/Education.css';const c = "_list_1ri0w_1", l = {
  "list-wrapper": "_list-wrapper_1ri0w_1",
  list: c
};
function h(n) {
  const {
    editable: i,
    education: r
  } = n;
  return /* @__PURE__ */ t(p, {
    onEditClick: i != null && i.isEditable ? i.onEditEducation : void 0,
    title: o("SUB_PROFILE_EDUCATION_HEADER"),
    children: /* @__PURE__ */ t("div", {
      children: r && r.length > 0 ? /* @__PURE__ */ t("ul", {
        className: l["list-wrapper"],
        children: r.map((s) => /* @__PURE__ */ t("li", {
          className: l.list,
          children: s.name
        }, s.id))
      }) : /* @__PURE__ */ t("span", {
        style: {
          fontStyle: "italic"
        },
        children: i != null && i.isEditable ? o("SUB_PROFILE_EDUCATION_EDIT_EMPTY") : o("SUB_PROFILE_NO_INFORMATION")
      })
    })
  });
}
export {
  h as Education
};
